import React from "react"
// import PropTypes from 'prop-types';
// Styles
import * as styles from "@/styles/modules/Hamburger.module.scss"

const Hamburger = ({ className, isOpen, onClick }) => {
  function handleClick(e) {
    onClick()
  }

  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      className={[
        styles.icon,
        className ? className : "",
        isOpen ? styles.active : "",
      ].join(" ")}
      onClick={handleClick}
    >
      <path
        d="M12 14H36C38.5 14 41 16 41 19C41 22 38.5 24 36 24H24"
        className={[styles.line, styles.top].join(" ")}
      />
      <path
        d="M12 24L36 24"
        className={[styles.line, styles.middle].join(" ")}
      />
      <path
        d="M36 34C36 34 14.5 34 12 34C9.5 34 7 32.1579 7 29.079C7 26 9.5 24 12 24C14.5 24 24 24 24 24"
        className={[styles.line, styles.bottom].join(" ")}
      />
    </svg>
  )
}

Hamburger.propTypes = {}

export default Hamburger
